import { useEffect, type FC } from "react";

interface SeoProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  keywords?: string;
  type?: "article" | "website";
}

const SITE_NAME = "Panacea Insights";

function setMeta(name: string, content: string, attr: "name" | "property" = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export const Seo: FC<SeoProps> = ({ title, description, image, url, keywords, type = "website" }) => {
  useEffect(() => {
    const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = pageTitle;

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description, "name");
    }

    setMeta("og:title", pageTitle, "property");
    setMeta("og:type", type, "property");
    setMeta("og:site_name", SITE_NAME, "property");
    setMeta("twitter:title", pageTitle, "name");
    setMeta("twitter:card", "summary_large_image", "name");

    if (image) {
      setMeta("og:image", image, "property");
      setMeta("twitter:image", image, "name");
    }

    if (url) {
      setMeta("og:url", url, "property");
      let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
    }

    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, image, url, keywords, type]);

  return null;
};
